(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blackfriday-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.customElements.get('bf-bundle')) return;

  function init(root){
  var LIST = [];
  try { LIST = JSON.parse(root.querySelector('[data-bf-data]').textContent); } catch(e) {}

  var PACKS = { 6: { price: +root.dataset.p6 || 55, label: '6-Pack' }, 12: { price: +root.dataset.p12 || 100, label: '12-Pack' } };
  var BLURBS = { classic: 'Soft cotton-spandex everyday pair', mesh: 'Breathable mesh + Bulge Boost pouch', ice: 'Cool-touch, ultra-light fabric' };
  var DATA = {}, STYLES = [];
  var BLURB_ORDER = [BLURBS.classic, BLURBS.mesh, BLURBS.ice];
  LIST.forEach(function(p, i){ if (p && p.variants && p.variants.length) { DATA[p.handle] = p; STYLES.push({ h: p.handle, name: p.name, blurb: BLURBS[p.handle] || BLURB_ORDER[i] || '' }); } });

  var HEX = { 'green':'#7d9a6e','yellow':'#e0b23c','orange':'#e2733a','light gray':'#c9c9c9','dark gray':'#5a5a5a','gray':'#8a8a8a',
    'black':'#1a1a1a','royal blue':'#2f4fb5','ice blue':'#a9cdea','salmon':'#f08e7a','light blue':'#9ec9f0','dark blue':'#1f3a6b','pink':'#f29aa8','white':'#f7f7f7' };

  var state = { pack: 12, style: STYLES[0] ? STYLES[0].h : null, size: null, counts: {} };
  var $ = function(id){ return root.querySelector('#' + id); };
  var money = function(n){ return '$' + n.toFixed(2).replace(/\.00$/, ''); };
  var esc = function(s){ var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function uniq(arr){ var o = [], seen = {}; arr.forEach(function(x){ if (!seen[x]) { seen[x] = 1; o.push(x); } }); return o; }
  function prod(){ return DATA[state.style]; }
  function sizes(){ return uniq(prod().variants.map(function(v){ return v.s; })); }
  function colors(){ return uniq(prod().variants.map(function(v){ return v.c; })); }
  function variant(c, s){ return prod().variants.filter(function(v){ return v.c === c && v.s === s; })[0]; }
  function sizeAvail(s){ return prod().variants.some(function(v){ return v.s === s && v.a; }); }
  function total(){ var t = 0; for (var k in state.counts) t += state.counts[k]; return t; }

  root.querySelectorAll('[data-pack]').forEach(function(b){
    b.addEventListener('click', function(){
      state.pack = +b.dataset.pack;
      root.querySelectorAll('[data-pack]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); });
      trimCounts(); render();
    });
  });

  function renderStyles(){
    $('bf-styles').innerHTML = STYLES.map(function(s){
      var img = DATA[s.h].image;
      return '<button type="button" class="bf-card bf-style" data-style="' + esc(s.h) + '" aria-pressed="' + (s.h === state.style) + '">' +
        (img ? '<img src="' + img + '" alt="HELLO ' + esc(s.name) + '" loading="lazy">' : '') +
        '<b>' + esc(s.name) + '</b><span class="bf-blurb">' + esc(s.blurb) + '</span></button>';
    }).join('');
    $('bf-styles').querySelectorAll('[data-style]').forEach(function(b){
      b.addEventListener('click', function(){
        if (state.style === b.dataset.style) return;
        state.style = b.dataset.style; state.counts = {};
        if (state.size && (sizes().indexOf(state.size) === -1 || !sizeAvail(state.size))) state.size = null;
        renderStyles(); render();
      });
    });
  }

  function renderSizes(){
    $('bf-sizes').innerHTML = sizes().map(function(s){
      var m = s.match(/^(\S+)\s*(\(.*\))?$/), main = m ? m[1] : s, sub = m && m[2] ? ' <small>' + esc(m[2]) + '</small>' : '';
      return '<button type="button" class="bf-size" data-size="' + esc(s) + '" aria-pressed="' + (s === state.size) + '"' + (sizeAvail(s) ? '' : ' disabled') + '>' + esc(main) + sub + '</button>';
    }).join('');
    $('bf-sizes').querySelectorAll('[data-size]').forEach(function(b){
      b.addEventListener('click', function(){
        state.size = b.dataset.size;
        for (var c in state.counts) { var v = variant(c, state.size); if (!v || !v.a) delete state.counts[c]; }
        render();
      });
    });
  }

  function renderColors(){
    var full = total() >= state.pack;
    $('bf-colors').innerHTML = colors().map(function(c){
      var v = state.size ? variant(c, state.size) : null;
      var ok = !state.size || (v && v.a);
      var img = (v && v.img) || (prod().variants.filter(function(x){ return x.c === c && x.img; })[0] || {}).img;
      var n = state.counts[c] || 0;
      var sw = img ? 'background-image:url(' + img + ')' : 'background:' + (HEX[c.toLowerCase()] || '#ccc');
      return '<div class="bf-color' + (n ? ' on' : '') + (ok ? '' : ' off') + '">' +
        '<div class="bf-color-top"><span class="bf-sw" style="' + sw + '"></span><span class="bf-color-n">' + esc(c) + (ok ? '' : '<br><small>Sold out</small>') + '</span></div>' +
        '<div class="bf-step-q"><button type="button" data-c="' + esc(c) + '" data-d="-1" aria-label="Remove ' + esc(c) + '"' + (n ? '' : ' disabled') + '><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 6h8"/></svg></button>' +
        '<b>' + n + '</b><button type="button" data-c="' + esc(c) + '" data-d="1" aria-label="Add ' + esc(c) + '"' + (ok && !full && state.size ? '' : ' disabled') + '><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 6h8M6 2v8"/></svg></button></div></div>';
    }).join('');
    $('bf-colors').querySelectorAll('[data-c]').forEach(function(b){
      b.addEventListener('click', function(){
        var c = b.dataset.c, d = +b.dataset.d, n = (state.counts[c] || 0) + d;
        if (d > 0 && total() >= state.pack) return;
        if (n <= 0) delete state.counts[c]; else state.counts[c] = n;
        render();
      });
    });
  }

  function trimCounts(){
    var over = total() - state.pack, keys = Object.keys(state.counts).reverse();
    while (over > 0 && keys.length) {
      var k = keys[0]; state.counts[k]--; over--;
      if (!state.counts[k]) { delete state.counts[k]; keys.shift(); }
    }
  }

  $('bf-mix').addEventListener('click', function(){
    if (!state.size) { flash('Choose your size first.'); return; }
    var avail = colors().filter(function(c){ var v = variant(c, state.size); return v && v.a; });
    if (!avail.length) return;
    state.counts = {};
    for (var i = 0; i < state.pack; i++) { var c = avail[i % avail.length]; state.counts[c] = (state.counts[c] || 0) + 1; }
    render();
  });
  $('bf-clear').addEventListener('click', function(){ state.counts = {}; render(); });

  function flash(msg){ var e = $('bf-err'); e.textContent = msg; e.style.display = 'block'; setTimeout(function(){ e.style.display = 'none'; }, 4000); }

  function render(){
    renderSizes(); renderColors();
    var t = total(), p = PACKS[state.pack], left = state.pack - t;
    var reg = prod().price / 100 * state.pack;
    var name = (STYLES.filter(function(s){ return s.h === state.style; })[0] || {}).name || '';
    $('bf-prog-t').textContent = !state.size ? 'Choose your size to pick colors' : t + ' of ' + state.pack + ' picked';
    $('bf-prog-b').style.width = (t / state.pack * 100) + '%';
    $('bf-sum-t').innerHTML = esc(name) + ' ' + p.label + (state.size ? ' · ' + esc(state.size.split(' ')[0]) : '') +
      '<br><b>' + money(p.price) + '</b>' + (reg > p.price ? '<s>' + money(reg) + '</s>' : '');
    var btn = $('bf-add');
    btn.disabled = !state.size || left !== 0;
    btn.textContent = !state.size ? 'Choose your size' : left > 0 ? 'Pick ' + left + ' more' : 'Add ' + p.label + ' to cart';
  }


  /* Other scripts (cart apps) can wrap window.fetch and crash on custom pages.
     Try a clean fetch from a blank iframe first, then the normal fetch, then plain XHR. */
  function cleanWin(){
    try {
      var f = document.getElementById('bf-clean-fetch');
      if (!f) { f = document.createElement('iframe'); f.id = 'bf-clean-fetch'; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden'; document.body.appendChild(f); }
      return f.contentWindow;
    } catch(e) { return null; }
  }
  function viaFetch(fn, method, url, body){
    return fn(url, { method: method, credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function(r){ return r.text().then(function(t){ return { ok: r.ok, status: r.status, text: t }; }); });
  }
  function viaXhr(X, method, url, body){
    return new Promise(function(res, rej){
      var x = new X(); x.open(method, url, true);
      x.setRequestHeader('Content-Type', 'application/json'); x.setRequestHeader('Accept', 'application/json'); x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.onload = function(){ res({ ok: x.status >= 200 && x.status < 300, status: x.status, text: x.responseText }); };
      x.onerror = function(){ rej(new Error('Network error')); };
      x.send(body || null);
    });
  }
  function request(method, path, data){
    var url = location.origin + path, body = data ? JSON.stringify(data) : undefined, cw = cleanWin();
    var tries = [];
    if (cw && typeof cw.fetch === 'function') tries.push(function(){ return viaFetch(cw.fetch.bind(cw), method, url, body); });
    if (cw && cw.XMLHttpRequest) tries.push(function(){ return viaXhr(cw.XMLHttpRequest, method, url, body); });
    tries.push(function(){ return viaFetch(window.fetch.bind(window), method, url, body); });
    tries.push(function(){ return viaXhr(XMLHttpRequest, method, url, body); });
    var i = 0, lastErr;
    function next(){
      if (i >= tries.length) return Promise.reject(lastErr || new Error('Could not reach the cart'));
      var t = tries[i++], p;
      try { p = t(); } catch(e) { lastErr = e; return next(); }
      return p.then(function(res){
        var json = null; try { json = JSON.parse(res.text); } catch(e) {}
        if (!json) { lastErr = new Error('Unexpected cart response (' + res.status + ')'); return next(); }
        return { ok: res.ok, json: json };
      }, function(e){ lastErr = e; console.warn('BLACK FRIDAY cart request failed, retrying:', e); return next(); });
    }
    return next();
  }

  /* Upcart replaces the theme drawer on this store; use its public API when present */
  function openUpcart(){
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch(e) { console.warn(e); }
    try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; } } catch(e) { console.warn(e); }
    return false;
  }
  function hasUpcart(){ return typeof window.upcartOpenCart === 'function'; }
  function waitFor(test, ms){
    return new Promise(function(res){
      if (test()) return res(true);
      var t0 = Date.now(), iv = setInterval(function(){
        if (test()) { clearInterval(iv); res(true); } else if (Date.now() - t0 > ms) { clearInterval(iv); res(false); }
      }, 100);
    });
  }

  function openDrawer(cart, added){
    if (hasUpcart()) { openUpcart(); return; }
    var drawer = document.querySelector('cart-drawer');
    var tv = window.themeVariables && window.themeVariables.settings;
    if (!drawer || (tv && tv.cartType === 'page')) {
      /* No theme drawer: give Upcart a moment to load before falling back to the cart page */
      waitFor(hasUpcart, 2500).then(function(ok){ if (ok) openUpcart(); else window.location.href = ROOT_URL + 'cart'; });
      return;
    }
    var drawerSection = drawer.closest('.shopify-section'), sid = drawerSection ? drawerSection.id.replace('shopify-section-', '') : null;
    var haveSections = cart && cart.sections && sid && cart.sections[sid];
    if (haveSections) {
      try { root.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart } })); } catch(e) { console.warn(e); }
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })); } catch(e) { console.warn(e); }
    } else {
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch(e) { console.warn(e); }
    }
    setTimeout(function(){
      if (drawer.hasAttribute('open')) return;
      try { if (typeof drawer.show === 'function') drawer.show(); else drawer.setAttribute('open', ''); } catch(e) { console.warn(e); }
    }, haveSections ? 300 : 700);
  }

  $('bf-add').addEventListener('click', function(){
    var btn = this;
    if (total() !== state.pack || !state.size) return;
    var tag = 'BLACK FRIDAY ' + PACKS[state.pack].label;
    var items = Object.keys(state.counts).map(function(c){
      return { id: variant(c, state.size).id, quantity: state.counts[c], properties: { _bundle: tag } };
    });
    btn.disabled = true; btn.textContent = 'Adding…';
    var sections = ['variant-added'];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })); } catch(e) {}
    request('POST', ROOT_URL + 'cart/add.js', { items: items, sections: sections.join(','), sections_url: ROOT_URL + 'variants/' + items[0].id })
      .then(function(res){
        if (!res.ok) { flash(res.json.description || res.json.message || 'Could not add to cart'); render(); return; }
        var added = res.json.items || [res.json];
        state.counts = {}; render();
        /* Items are in the cart now. Everything below only updates and opens the drawer, never re-adds. */
        return request('GET', ROOT_URL + 'cart.js')
          .then(function(c){ var cart = c.json; cart.sections = res.json.sections || {}; openDrawer(cart, added); })
          .catch(function(e){ console.warn(e); openDrawer(null, added); });
      })
      .catch(function(err){ console.error('BLACK FRIDAY add to cart:', err); flash('Could not add to cart: ' + (err && err.message || 'unknown error')); render(); });
  });


  /* Size chart */
  var sc = root.querySelector('[data-sc]');
  if (sc) {
    var scOpen = function(){ sc.classList.add('open'); document.documentElement.style.overflow = 'hidden'; var x = sc.querySelector('[data-sc-close]'); if (x) x.focus(); };
    var scClose = function(){ sc.classList.remove('open'); document.documentElement.style.overflow = ''; };
    root.querySelectorAll('[data-sc-open]').forEach(function(b){ b.addEventListener('click', scOpen); });
    sc.querySelector('[data-sc-close]').addEventListener('click', scClose);
    sc.addEventListener('click', function(e){ if (e.target === sc) scClose(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sc.classList.contains('open')) scClose(); });
    sc.querySelectorAll('[data-sc-unit]').forEach(function(b){
      b.addEventListener('click', function(){
        var u = b.dataset.scUnit;
        sc.querySelectorAll('[data-sc-unit]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); });
        sc.querySelectorAll('[data-sc-row]').forEach(function(r){ r.hidden = r.dataset.scRow !== u; });
      });
    });
  }

  if (STYLES.length) { renderStyles(); render(); }
  else { $('bf-styles').innerHTML = '<p style="color:#c0392b">Products could not be loaded. Pick Style 1–3 in the section settings.</p>'; }
  }

  class HwBundle extends HTMLElement {
    connectedCallback(){ if (this._bfInit) return; this._bfInit = true; try { init(this); } catch(e) { console.error('BLACK FRIDAY bundle:', e); } }
  }
  customElements.define('bf-bundle', HwBundle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["early-black-friday"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.customElements.get('ebf-page')) return;
  class EbfPage extends HTMLElement {
    connectedCallback(){
      var tp = this.querySelector('[data-tp-wrap] .trustpilot-widget');
      if (tp) {
        var load = function(){ try { window.Trustpilot && window.Trustpilot.loadFromElement(tp, true); } catch(e) {} };
        if (window.Trustpilot) load();
        else if (!document.querySelector('script[src*="tp.widget.bootstrap"]')) {
          var sc = document.createElement('script'); sc.async = true; sc.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'; sc.onload = load; document.head.appendChild(sc);
        } else { window.addEventListener('load', load); }
      }
      var cd = this.querySelector('[data-cd]');
      var end = new Date(this.dataset.end).getTime();
      if (!cd) return;
      if (isNaN(end)) { cd.hidden = true; return; }
      var units = cd.querySelectorAll('[data-u]'), self = this;
      var tick = function(){
        var ms = end - Date.now();
        if (ms <= 0) { cd.hidden = true; clearInterval(self._t); return; }
        var s = Math.floor(ms / 1000), u = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        units.forEach(function(el){ el.textContent = String(u[el.dataset.u]).padStart(2, '0'); });
      };
      tick(); this._t = setInterval(tick, 1000);
    }
    disconnectedCallback(){ clearInterval(this._t); }
  }
  customElements.define('ebf-page', EbfPage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helloween-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.customElements.get('hw-bundle')) return;

  function init(root){
  var LIST = [];
  try { LIST = JSON.parse(root.querySelector('[data-hw-data]').textContent); } catch(e) {}

  var PACKS = { 6: { price: +root.dataset.p6 || 55, label: '6-Pack' }, 12: { price: +root.dataset.p12 || 100, label: '12-Pack' } };
  var BLURBS = { classic: 'Soft cotton-spandex everyday pair', mesh: 'Breathable mesh + Bulge Boost pouch', ice: 'Cool-touch, ultra-light fabric' };
  var DATA = {}, STYLES = [];
  var BLURB_ORDER = [BLURBS.classic, BLURBS.mesh, BLURBS.ice];
  LIST.forEach(function(p, i){ if (p && p.variants && p.variants.length) { DATA[p.handle] = p; STYLES.push({ h: p.handle, name: p.name, blurb: BLURBS[p.handle] || BLURB_ORDER[i] || '' }); } });

  var HEX = { 'green':'#7d9a6e','yellow':'#e0b23c','orange':'#e2733a','light gray':'#c9c9c9','dark gray':'#5a5a5a','gray':'#8a8a8a',
    'black':'#1a1a1a','royal blue':'#2f4fb5','ice blue':'#a9cdea','salmon':'#f08e7a','light blue':'#9ec9f0','dark blue':'#1f3a6b','pink':'#f29aa8','white':'#f7f7f7' };

  var state = { pack: 12, style: STYLES[0] ? STYLES[0].h : null, size: null, counts: {} };
  var $ = function(id){ return root.querySelector('#' + id); };
  var money = function(n){ return '$' + n.toFixed(2).replace(/\.00$/, ''); };
  var esc = function(s){ var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function uniq(arr){ var o = [], seen = {}; arr.forEach(function(x){ if (!seen[x]) { seen[x] = 1; o.push(x); } }); return o; }
  function prod(){ return DATA[state.style]; }
  function sizes(){ return uniq(prod().variants.map(function(v){ return v.s; })); }
  function colors(){ return uniq(prod().variants.map(function(v){ return v.c; })); }
  function variant(c, s){ return prod().variants.filter(function(v){ return v.c === c && v.s === s; })[0]; }
  function sizeAvail(s){ return prod().variants.some(function(v){ return v.s === s && v.a; }); }
  function total(){ var t = 0; for (var k in state.counts) t += state.counts[k]; return t; }

  root.querySelectorAll('[data-pack]').forEach(function(b){
    b.addEventListener('click', function(){
      state.pack = +b.dataset.pack;
      root.querySelectorAll('[data-pack]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); });
      trimCounts(); render();
    });
  });

  function renderStyles(){
    $('hw-styles').innerHTML = STYLES.map(function(s){
      var img = DATA[s.h].image;
      return '<button type="button" class="hw-card hw-style" data-style="' + esc(s.h) + '" aria-pressed="' + (s.h === state.style) + '">' +
        (img ? '<img src="' + img + '" alt="HELLO ' + esc(s.name) + '" loading="lazy">' : '') +
        '<b>' + esc(s.name) + '</b><span class="hw-blurb">' + esc(s.blurb) + '</span></button>';
    }).join('');
    $('hw-styles').querySelectorAll('[data-style]').forEach(function(b){
      b.addEventListener('click', function(){
        if (state.style === b.dataset.style) return;
        state.style = b.dataset.style; state.counts = {};
        if (state.size && (sizes().indexOf(state.size) === -1 || !sizeAvail(state.size))) state.size = null;
        renderStyles(); render();
      });
    });
  }

  function renderSizes(){
    $('hw-sizes').innerHTML = sizes().map(function(s){
      var m = s.match(/^(\S+)\s*(\(.*\))?$/), main = m ? m[1] : s, sub = m && m[2] ? ' <small>' + esc(m[2]) + '</small>' : '';
      return '<button type="button" class="hw-size" data-size="' + esc(s) + '" aria-pressed="' + (s === state.size) + '"' + (sizeAvail(s) ? '' : ' disabled') + '>' + esc(main) + sub + '</button>';
    }).join('');
    $('hw-sizes').querySelectorAll('[data-size]').forEach(function(b){
      b.addEventListener('click', function(){
        state.size = b.dataset.size;
        for (var c in state.counts) { var v = variant(c, state.size); if (!v || !v.a) delete state.counts[c]; }
        render();
      });
    });
  }

  function renderColors(){
    var full = total() >= state.pack;
    $('hw-colors').innerHTML = colors().map(function(c){
      var v = state.size ? variant(c, state.size) : null;
      var ok = !state.size || (v && v.a);
      var img = (v && v.img) || (prod().variants.filter(function(x){ return x.c === c && x.img; })[0] || {}).img;
      var n = state.counts[c] || 0;
      var sw = img ? 'background-image:url(' + img + ')' : 'background:' + (HEX[c.toLowerCase()] || '#ccc');
      return '<div class="hw-color' + (n ? ' on' : '') + (ok ? '' : ' off') + '">' +
        '<div class="hw-color-top"><span class="hw-sw" style="' + sw + '"></span><span class="hw-color-n">' + esc(c) + (ok ? '' : '<br><small>Sold out</small>') + '</span></div>' +
        '<div class="hw-step-q"><button type="button" data-c="' + esc(c) + '" data-d="-1" aria-label="Remove ' + esc(c) + '"' + (n ? '' : ' disabled') + '><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 6h8"/></svg></button>' +
        '<b>' + n + '</b><button type="button" data-c="' + esc(c) + '" data-d="1" aria-label="Add ' + esc(c) + '"' + (ok && !full && state.size ? '' : ' disabled') + '><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 6h8M6 2v8"/></svg></button></div></div>';
    }).join('');
    $('hw-colors').querySelectorAll('[data-c]').forEach(function(b){
      b.addEventListener('click', function(){
        var c = b.dataset.c, d = +b.dataset.d, n = (state.counts[c] || 0) + d;
        if (d > 0 && total() >= state.pack) return;
        if (n <= 0) delete state.counts[c]; else state.counts[c] = n;
        render();
      });
    });
  }

  function trimCounts(){
    var over = total() - state.pack, keys = Object.keys(state.counts).reverse();
    while (over > 0 && keys.length) {
      var k = keys[0]; state.counts[k]--; over--;
      if (!state.counts[k]) { delete state.counts[k]; keys.shift(); }
    }
  }

  $('hw-mix').addEventListener('click', function(){
    if (!state.size) { flash('Choose your size first.'); return; }
    var avail = colors().filter(function(c){ var v = variant(c, state.size); return v && v.a; });
    if (!avail.length) return;
    state.counts = {};
    for (var i = 0; i < state.pack; i++) { var c = avail[i % avail.length]; state.counts[c] = (state.counts[c] || 0) + 1; }
    render();
  });
  $('hw-clear').addEventListener('click', function(){ state.counts = {}; render(); });

  function flash(msg){ var e = $('hw-err'); e.textContent = msg; e.style.display = 'block'; setTimeout(function(){ e.style.display = 'none'; }, 4000); }

  function render(){
    renderSizes(); renderColors();
    var t = total(), p = PACKS[state.pack], left = state.pack - t;
    var reg = prod().price / 100 * state.pack;
    var name = (STYLES.filter(function(s){ return s.h === state.style; })[0] || {}).name || '';
    $('hw-prog-t').textContent = !state.size ? 'Choose your size to pick colors' : t + ' of ' + state.pack + ' picked';
    $('hw-prog-b').style.width = (t / state.pack * 100) + '%';
    $('hw-sum-t').innerHTML = esc(name) + ' ' + p.label + (state.size ? ' · ' + esc(state.size.split(' ')[0]) : '') +
      '<br><b>' + money(p.price) + '</b>' + (reg > p.price ? '<s>' + money(reg) + '</s>' : '');
    var btn = $('hw-add');
    btn.disabled = !state.size || left !== 0;
    btn.textContent = !state.size ? 'Choose your size' : left > 0 ? 'Pick ' + left + ' more' : 'Add ' + p.label + ' to cart';
  }


  /* Other scripts (cart apps) can wrap window.fetch and crash on custom pages.
     Try a clean fetch from a blank iframe first, then the normal fetch, then plain XHR. */
  function cleanWin(){
    try {
      var f = document.getElementById('hw-clean-fetch');
      if (!f) { f = document.createElement('iframe'); f.id = 'hw-clean-fetch'; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden'; document.body.appendChild(f); }
      return f.contentWindow;
    } catch(e) { return null; }
  }
  function viaFetch(fn, method, url, body){
    return fn(url, { method: method, credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function(r){ return r.text().then(function(t){ return { ok: r.ok, status: r.status, text: t }; }); });
  }
  function viaXhr(X, method, url, body){
    return new Promise(function(res, rej){
      var x = new X(); x.open(method, url, true);
      x.setRequestHeader('Content-Type', 'application/json'); x.setRequestHeader('Accept', 'application/json'); x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.onload = function(){ res({ ok: x.status >= 200 && x.status < 300, status: x.status, text: x.responseText }); };
      x.onerror = function(){ rej(new Error('Network error')); };
      x.send(body || null);
    });
  }
  function request(method, path, data){
    var url = location.origin + path, body = data ? JSON.stringify(data) : undefined, cw = cleanWin();
    var tries = [];
    if (cw && typeof cw.fetch === 'function') tries.push(function(){ return viaFetch(cw.fetch.bind(cw), method, url, body); });
    if (cw && cw.XMLHttpRequest) tries.push(function(){ return viaXhr(cw.XMLHttpRequest, method, url, body); });
    tries.push(function(){ return viaFetch(window.fetch.bind(window), method, url, body); });
    tries.push(function(){ return viaXhr(XMLHttpRequest, method, url, body); });
    var i = 0, lastErr;
    function next(){
      if (i >= tries.length) return Promise.reject(lastErr || new Error('Could not reach the cart'));
      var t = tries[i++], p;
      try { p = t(); } catch(e) { lastErr = e; return next(); }
      return p.then(function(res){
        var json = null; try { json = JSON.parse(res.text); } catch(e) {}
        if (!json) { lastErr = new Error('Unexpected cart response (' + res.status + ')'); return next(); }
        return { ok: res.ok, json: json };
      }, function(e){ lastErr = e; console.warn('HELLOWEEN cart request failed, retrying:', e); return next(); });
    }
    return next();
  }

  /* Upcart replaces the theme drawer on this store; use its public API when present */
  function openUpcart(){
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch(e) { console.warn(e); }
    try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; } } catch(e) { console.warn(e); }
    return false;
  }
  function hasUpcart(){ return typeof window.upcartOpenCart === 'function'; }
  function waitFor(test, ms){
    return new Promise(function(res){
      if (test()) return res(true);
      var t0 = Date.now(), iv = setInterval(function(){
        if (test()) { clearInterval(iv); res(true); } else if (Date.now() - t0 > ms) { clearInterval(iv); res(false); }
      }, 100);
    });
  }

  function openDrawer(cart, added){
    if (hasUpcart()) { openUpcart(); return; }
    var drawer = document.querySelector('cart-drawer');
    var tv = window.themeVariables && window.themeVariables.settings;
    if (!drawer || (tv && tv.cartType === 'page')) {
      /* No theme drawer: give Upcart a moment to load before falling back to the cart page */
      waitFor(hasUpcart, 2500).then(function(ok){ if (ok) openUpcart(); else window.location.href = ROOT_URL + 'cart'; });
      return;
    }
    var drawerSection = drawer.closest('.shopify-section'), sid = drawerSection ? drawerSection.id.replace('shopify-section-', '') : null;
    var haveSections = cart && cart.sections && sid && cart.sections[sid];
    if (haveSections) {
      try { root.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart } })); } catch(e) { console.warn(e); }
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })); } catch(e) { console.warn(e); }
    } else {
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch(e) { console.warn(e); }
    }
    setTimeout(function(){
      if (drawer.hasAttribute('open')) return;
      try { if (typeof drawer.show === 'function') drawer.show(); else drawer.setAttribute('open', ''); } catch(e) { console.warn(e); }
    }, haveSections ? 300 : 700);
  }

  $('hw-add').addEventListener('click', function(){
    var btn = this;
    if (total() !== state.pack || !state.size) return;
    var tag = 'HELLOWEEN ' + PACKS[state.pack].label;
    var items = Object.keys(state.counts).map(function(c){
      return { id: variant(c, state.size).id, quantity: state.counts[c], properties: { _bundle: tag } };
    });
    btn.disabled = true; btn.textContent = 'Adding…';
    var sections = ['variant-added'];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })); } catch(e) {}
    request('POST', ROOT_URL + 'cart/add.js', { items: items, sections: sections.join(','), sections_url: ROOT_URL + 'variants/' + items[0].id })
      .then(function(res){
        if (!res.ok) { flash(res.json.description || res.json.message || 'Could not add to cart'); render(); return; }
        var added = res.json.items || [res.json];
        state.counts = {}; render();
        /* Items are in the cart now. Everything below only updates and opens the drawer, never re-adds. */
        return request('GET', ROOT_URL + 'cart.js')
          .then(function(c){ var cart = c.json; cart.sections = res.json.sections || {}; openDrawer(cart, added); })
          .catch(function(e){ console.warn(e); openDrawer(null, added); });
      })
      .catch(function(err){ console.error('HELLOWEEN add to cart:', err); flash('Could not add to cart: ' + (err && err.message || 'unknown error')); render(); });
  });


  /* Size chart */
  var sc = root.querySelector('[data-sc]');
  if (sc) {
    var scOpen = function(){ sc.classList.add('open'); document.documentElement.style.overflow = 'hidden'; var x = sc.querySelector('[data-sc-close]'); if (x) x.focus(); };
    var scClose = function(){ sc.classList.remove('open'); document.documentElement.style.overflow = ''; };
    root.querySelectorAll('[data-sc-open]').forEach(function(b){ b.addEventListener('click', scOpen); });
    sc.querySelector('[data-sc-close]').addEventListener('click', scClose);
    sc.addEventListener('click', function(e){ if (e.target === sc) scClose(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sc.classList.contains('open')) scClose(); });
    sc.querySelectorAll('[data-sc-unit]').forEach(function(b){
      b.addEventListener('click', function(){
        var u = b.dataset.scUnit;
        sc.querySelectorAll('[data-sc-unit]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); });
        sc.querySelectorAll('[data-sc-row]').forEach(function(r){ r.hidden = r.dataset.scRow !== u; });
      });
    });
  }

  if (STYLES.length) { renderStyles(); render(); }
  else { $('hw-styles').innerHTML = '<p style="color:#c0392b">Products could not be loaded. Pick Style 1–3 in the section settings.</p>'; }
  }

  class HwBundle extends HTMLElement {
    connectedCallback(){ if (this._hwInit) return; this._hwInit = true; try { init(this); } catch(e) { console.error('HELLOWEEN bundle:', e); } }
  }
  customElements.define('hw-bundle', HwBundle);
})();

  } catch(e) { console.error(e); }
})();
})();
